import * as classNames from 'classnames'
import * as React from 'react'
import {Text, TYPOGRAPHY} from 'wix-ui-tpa/Text'
import s from './no-events-text.st.css'

export const NoEventsText = props => (
  <Text typography={TYPOGRAPHY.smallTitle} {...props} className={classNames(s.root, {[s.mobile]: props.mobile})} />
)
